@if (inited) {
  <div>
    <sm-toolbar>
      <p-button icon="fas fa-save" label="Speichern" (onClick)="save()">
      </p-button>
    </sm-toolbar>
    <sm-tab-view class="col-12">
      <sm-tab header="Ergebnisse">
        <p-table class="p-datatable-gridlines" [value]="rows">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:155px" rowspan=2>Nachname</th>
              <th style="width:155px" rowspan=2>Vorname</th>
              @for (day of covidTestDays; track day) {
                <th style="width: 150px; max-width: 150px" colspan=3>{{day.day | date: 'dd.MM.yyyy'}}</th>
              }
            </tr>
            <tr>
              @for (day of covidTestDays; track day; let index = $index) {
                <th style="width: 50px; max-width: 50px">Nasal</th>
                <th style="width: 50px; max-width: 50px">Speichel</th>
                <th style="width: 50px; max-width: 50px">Selbst</th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-index="rowIndex">
            <tr [pSelectableRow]="row">
              @if (row.pupilId != 0) {
                <td>{{pupilsById[row.pupilId].lastName}}</td>
              }
              @if (row.pupilId == 0) {
                <td pEditableColumn>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-select class="width100" id="person" [options]="personOptions" [ngModel]="row.person" (ngModelChange)="changePerson($event, row)">
                      </p-select>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{row.person}}
                    </ng-template>
                  </p-cellEditor>
                </td>
              }
              <td>{{row.pupilId != 0 ? pupilsById[row.pupilId].firstName : ''}}</td>
              @for (day of covidTestDays; track day; let index = $index) {
                @if (row.tests[index] != null) {
                  <td><sm-check-box-with-count [(value)]="row.tests[index].numNasal" [max]=3></sm-check-box-with-count></td>
                  <td><sm-check-box-with-count [(value)]="row.tests[index].numSaliva" [max]=3></sm-check-box-with-count></td>
                  <td><sm-check-box-with-count [(value)]="row.tests[index].numSelf" [max]=3></sm-check-box-with-count></td>
                }
                @if (row.tests[index] == null) {
                  <td></td>
                  <td></td>
                  <td></td>
                }
              }
            </tr>
          </ng-template>
          @if (history) {
            <ng-template pTemplate="footer">
              @for (person of [[''], ['Lehrer'], ['upF'], ['B', 's. Pers.'], null]; track person) {
                <tr>
                  <td>Gesamtsumme {{person == null ? '' : person[0] == '' ? "Schüler" : person}}</td>
                  <td></td>
                  @for (day of covidTestDays; track day; let index = $index) {
                    <td>{{getSum(index, null, person, 0)}}</td>
                    <td>{{getSum(index, null, person, 1)}}</td>
                    <td>{{getSum(index, null, person, 2)}}</td>
                  }
                </tr>
              }
            </ng-template>
          }
        </p-table>
        @if (!history) {
          <sm-toolbar>
            <p-button icon="fas fa-add" label="Neue Zeile" (onClick)="addRow()">
            </p-button>
          </sm-toolbar>
        }
      </sm-tab>
      @if (history) {
        <sm-tab header="Auswertung">
          <p-table class="p-datatable-gridlines" [value]="[[''], ['Lehrer'], ['upF'], ['B', 's. Pers.'], null]">
            <ng-template pTemplate="header">
              <tr>
                <th style="width:155px" rowspan=2>Kategorie</th>
                <ng-container >
                  @for (week of calendarWeeks; track week) {
                    <th style="width: 50px; max-width: 50px" colspan=4>KW {{week}}</th>
                  }
                </ng-container>
              </tr>
              <tr>
                @for (week of calendarWeeks; track week) {
                  <th style="width: 50px; max-width: 50px">Nasal</th>
                  <th style="width: 50px; max-width: 50px">Speichel</th>
                  <th style="width: 50px; max-width: 50px">Selbst</th>
                  <th style="width: 50px; max-width: 50px">Gesamt</th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-index="rowIndex">
              <tr [pSelectableRow]="row">
                <td>Gesamtsumme {{row == null ? '' : row[0] == '' ? "Schüler" : _Arrays.itemsToString(row)}}</td>
                @for (week of calendarWeeks; track week) {
                  <td>{{getSum(null, week, row, 0)}}</td>
                  <td>{{getSum(null, week, row, 1)}}</td>
                  <td>{{getSum(null, week, row, 2)}}</td>
                  <td>{{getSum(null, week, row, -1)}}</td>
                }
              </tr>
            </ng-template>
          </p-table>
        </sm-tab>
      }
    </sm-tab-view>
  </div>
}
